var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiftingWeights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8079;}\n\t.st1{fill:#004137;}\n\t.st2{fill:#B9CFC0;}\n\t.st3{fill:#F1F1F1;}\n\t.st4{fill:#CCCBCB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,182.8c42.7,0,77.3-34.3,77.3-76.6c0-42.3-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C29.2,148.5,63.8,182.8,106.5,182.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.3,81.4c3.4,0,6.2,2.8,6.2,6.2v37.2c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2V87.6 C133.1,84.2,135.9,81.4,139.3,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.9,81.4c3.2,0,5.8,2.7,5.8,6v36.2c0,3.3-2.6,6-5.8,6c-3.2,0-5.8-2.7-5.8-6V87.4 C133.1,84.1,135.7,81.4,138.9,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.6,85.7c2.8,0,5.1,2.3,5.1,5.1v30.7c0,2.8-2.3,5.1-5.1,5.1c-2.8,0-5.1-2.3-5.1-5.1V90.8 C145.5,88,147.8,85.7,150.6,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.3,85.7c2.6,0,4.8,2.2,4.8,5v29.9c0,2.7-2.1,5-4.8,5c-2.6,0-4.8-2.2-4.8-5V90.7 C145.5,87.9,147.7,85.7,150.3,85.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8,90.1c2.2,0,4,1.8,4,4v24.2c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4V94.1C155.7,91.9,157.5,90.1,159.8,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.5,90.1c2.1,0,3.8,1.8,3.8,3.9v23.5c0,2.2-1.7,3.9-3.8,3.9c-2.1,0-3.8-1.7-3.8-3.9V94 C155.7,91.8,157.4,90.1,159.5,90.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.7,81.4c-3.4,0-6.2,2.8-6.2,6.2v37.2c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2V87.6 C79.9,84.2,77.1,81.4,73.7,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.3,81.4c-3.2,0-5.8,2.7-5.8,6v36.2c0,3.3,2.6,6,5.8,6c3.2,0,5.8-2.7,5.8-6V87.4 C79.1,84.1,76.5,81.4,73.3,81.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.4,85.7c-2.8,0-5.1,2.3-5.1,5.1v30.7c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V90.8 C67.5,88,65.2,85.7,62.4,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62,85.7c-2.6,0-4.8,2.2-4.8,5v29.9c0,2.7,2.1,5,4.8,5c2.6,0,4.8-2.2,4.8-5V90.7C66.8,87.9,64.7,85.7,62,85.7 z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 101.9,
    className: "st3",
    width: 54.1,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.1,
    y: 107.9,
    className: "st4",
    width: 54.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.2,90.1c-2.2,0-4,1.8-4,4v24.2c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4V94.1C57.3,91.9,55.5,90.1,53.2,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53,90.1c-2.1,0-3.8,1.8-3.8,3.9v23.5c0,2.2,1.7,3.9,3.8,3.9c2.1,0,3.8-1.7,3.8-3.9V94 C56.8,91.8,55.1,90.1,53,90.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftingWeights);
export default __webpack_public_path__ + "static/media/Lifting_weights.eaec102d158dcff329881c5888b10b54.svg";
export { ForwardRef as ReactComponent };